import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Room } from './model/room.model';
import { Action, createReducer, on } from '@ngrx/store';
import { RoomActions } from './room.actions';

export const roomFeatureKey = 'room';

export const roomAdapter: EntityAdapter<Room> = createEntityAdapter<Room>();

export interface State extends EntityState<Room> {
    selectedRoomId: number;
}

export const initialState: State = roomAdapter.getInitialState({
    selectedRoomId: 0
});

const roomReducer = createReducer(
    initialState,
    on(RoomActions.loadRoomsSuccess, (state, { rooms }) => roomAdapter.addMany(rooms, { ...state, selectedRoomId: 0 })),
    on(RoomActions.createRoomSuccess, (state, { room }) => roomAdapter.addOne(room, { ...state, selectedRoomId: room.id || 0 }))
);

export function reducer(state: State | undefined, action: Action) {
    return roomReducer(state, action);
}
